export const indianNames = [
  "Aarav",
  "Aisha",
  "Akash",
  "Ananya",
  "Arjun",
  "Aryan",
  "Ayush",
  "Ayesha",
  "Rohan",
  "Bhavya",
  "Aditya",
  "Siddharth",
  "Varun",
  "Kunal",
  "Aisha",
  "Vikram",
  "Abhinav",
  "Siddharth",
  "Aniket",
  "Ayesha",
  "Rahul",
  "Sameer",
  "Karan",
  "Harsh",
  "Pranav",
  "Aarav",
  "Esha",
  "Ananya",
  "Kavya",
  "Ishita",
  "Yash",
  "Aisha",
  "Aarushi",
  "Aryan",
  "Simran",
  "Akshara",
  "Ayush",
  "Kunal",
  "Nisha",
  "Ayesha",
  "Dhruv",
  "Varun",
  "Tanvi",
  "Bhavya",
  "Simran",
  "Abhinav",
  "Rahul",
  "Aisha",
  "Ananya",
  "Aniket",
  "Zara",
  "Sameer",
  "Karan",
  "Nandini",
  "Esha",
  "Pranav",
  "Aarav",
  "Yash",
  "Siddharth",
  "Riya",
  "Ayesha",
  "Aryan",
  "Kunal",
  "Ishita",
  "Varun",
  "Trisha",
  "Rahul",
  "Simran",
  "Harsh",
  "Tanvi",
  "Pranav",
  "Pooja",
  "Karan",
  "Abhinav",
  "Aisha",
  "Zara",
  "Dhruv",
  "Aniket",
  "Nandini",
  "Vaishnavi",
  "Vikram",
  "Ananya",
  "Arjun",
  "Ayesha",
  "Sameer",
  "Kunal",
  "Aryan",
  "Esha",
  "Aisha",
  "Ayush",
  "Riya",
  "Pooja",
  "Aarushi",
  "Harsh",
  "Aryan",
  "Ayesha",
  "Ishita",
  "Simran",
  "Pranav",
  "Varun",
];

export const interval = 20000;
